import { BuilderType, projectsCacheTags } from './projectsApiHelpers';
import type { AMAsset } from '../../legacy/providers/types/redux-states/AMAsset';

export const miscApi = (builder: BuilderType) => ({
  getAMAssetBySerial: builder.query<AMAsset, string>({
    query: (serial) => `/service/am-assets/${encodeURIComponent(serial)}`,
    providesTags: [projectsCacheTags.FLEETS],
  }),

  sendPasswordResetEmail: builder.mutation<unknown, string>({
    query: (email) => ({
      url: `service/send-password-reset`,
      method: 'PUT',
      body: { email },
    }),
  }),

  clearAMUnexpectedAssetList: builder.mutation<unknown, number[]>({
    query: (ids) => ({
      url: '/service/am-unexpected-assets/clear-list',
      method: 'POST',
      body: { ids },
    }),
    invalidatesTags: [projectsCacheTags.FLEETS],
  }),

  ignoreAMAssetList: builder.mutation<unknown, number[]>({
    query: (ids) => ({
      url: '/service/am-assets/ignore-list',
      method: 'POST',
      body: { ids },
    }),
    invalidatesTags: [projectsCacheTags.FLEETS],
  }),

  unIgnoreAMAssetList: builder.mutation<unknown, number[]>({
    query: (ids) => ({
      url: '/service/am-assets/un-ignore-list',
      method: 'POST',
      body: { ids },
    }),
    invalidatesTags: [projectsCacheTags.FLEETS],
  }),
});
